import { Workspace } from "../types"

export default class WorkspaceHelper {
	static getAddress(workspace: Workspace) {
		const { street, city, province, zip_code } = workspace

		return [street, city, province, zip_code].filter(Boolean).join(' ')
	}
}